/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class PathSnapshotsRequest {
  /**
  * The path of the file
  */
  'path': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PathSnapshotsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

